import type { ReactFormExtendedApi } from "@tanstack/react-form";
import z from "zod";

export interface SiteEntrance {
  id?: string;
  name: string;
  lat: number;
  lon: number;
  plusCode?: string | null;
  publicCode?: string | null;
  geofenceDistance: number;
  isPrimary?: boolean;
}

export interface EntranceFormValues {
  name: string;
  geofenceDistance: string;
  lat: number | null;
  lon: number | null;
  plusCode: string;
}

export const entranceGeofenceOptions = [
  "50",
  "100",
  "200",
  "500",
  "1000",
] as const;

export const entranceFormSchema = z
  .object({
    name: z.string().trim().min(1, "Entrance name is required"),
    geofenceDistance: z
      .string()
      .refine(
        (value) =>
          entranceGeofenceOptions.includes(
            value as (typeof entranceGeofenceOptions)[number]
          ),
        "Select a geofence distance"
      ),
    lat: z.number().nullable(),
    lon: z.number().nullable(),
    plusCode: z.string(),
  })
  .refine(
    (value) =>
      typeof value.lat === "number" &&
      Number.isFinite(value.lat) &&
      typeof value.lon === "number" &&
      Number.isFinite(value.lon),
    {
      message: "Select an entrance location on the map",
      path: ["lat"],
    }
  );

// biome-ignore lint/suspicious/noExplicitAny: TanStack Form infers validator generics from the concrete useForm call, so this alias stays intentionally broad.
type AnyFormValidator = any;

export type EntranceFormApi = ReactFormExtendedApi<
  EntranceFormValues,
  AnyFormValidator,
  AnyFormValidator,
  AnyFormValidator,
  AnyFormValidator,
  AnyFormValidator,
  AnyFormValidator,
  AnyFormValidator,
  AnyFormValidator,
  AnyFormValidator,
  AnyFormValidator,
  unknown
>;
